import React from 'react'

import MyhouseCommonProgress from '@Components/atoms/MyhouseCommonProgress'

type Props = {
  showGuide: boolean
}

const MyhouseAuthProgress: React.FC<Props> = ({ showGuide }: Props) => {
  return <MyhouseCommonProgress title={'인증 방법을 찾고 있습니다.'} subtitle={(showGuide && '1분 정도 소요될 수 있습니다.') || ''} isViewportHeight />
}
export default MyhouseAuthProgress
